<template>
  <el-dialog class="custon-dialog-title" title="Editar Contato com Pretendente" @open="reset()" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="40%" v-loading="isLoading">
    <!-- EM ANDAMENTO/CONCLUIDO-->
    <el-form :model="contatoRealizado" :rules="validacaoCampos" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false">   
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Data/Hora</label>
            <span>{{contatoRealizado.data}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Atendente</label>
            <span>{{contatoRealizado.usuario.nome}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Assunto</label>
            <span>{{contatoRealizado.assunto}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Descrição</label>
            <span v-html="descricaoAnterior"></span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="isConcluido"> 
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Motivo da Finalização</label>
            <span>{{contatoRealizado.motivoFinalizacao}}</span>
          </div>
        </el-col>
      </el-row>
      
      <el-row :gutter="10" v-if="isEmAndamento">
        <el-col :span="24" :xs="13">
          <el-form-item class="form-item" label="Data/Hora de Retorno" prop="dataProximoContato">
            <el-date-picker
              v-model="contatoRealizado.dataProximoContato"
              placeholder="01/01/2019 16:00"
              v-mask="'##/##/#### ##:##'"
              :disabled="isConcluido"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              value-format="dd/MM/yyyy HH:mm"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10" v-if="isEmAndamento">
        <el-col :span="24">
          <el-form-item class="form-item" label="Adicionar à Descrição">
            <el-input :disabled="isConcluido" v-model="descricaoAux" type="textarea" :rows="4"></el-input> 
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>  
    <span slot="footer">
      <el-button v-if="!isNovo" type="danger" size="small" @click="fechar()" round class="btn-box-shadow">Fechar</el-button>
      <el-button v-if="!isConcluido" type="success" size="small" @click="gravar()" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { validadorDataHora } from '../../../util/validadores.js'


export default {
  props: {
    contato: Object,
    visibility: Boolean
  },
  data() {
    return {
      validacao: {
        dataProximoContato: [
          { validator: validadorDataHora, trigger: 'blur' },
        ]
      },
      descricaoAux: ""
    }
  },
  computed: {
    ...mapState('alugueisClientesStore', {
      cliente(state) { return state.clienteSelecionado }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('alugueisClientesStore', [
      'atualizarContatoRealizado'
    ]),
    validarDescricao(){
      return this.descricaoAux.trim().length > 0
    },
    gravar(){
      this.$refs['form'].validate((valid) => {
        if(valid && this.validarDescricao()){
          this.contato.cliente = { id: this.cliente.id };
          this.contato.descricao = this.descricaoAux + this.funcoes.agora2();
          this.showLoading();
          this.atualizarContatoRealizado(this.contato).then((response) => {
            this.hideLoading();
            switch(response.status) {
              case "SUCESSO":
                this.console.log(response);
                this.contato = { id: 0 };
                this.$message.success(response.mensagem);
                this.fechar();
                break;
              case "FALHA":
                this.$message.warning(response.mensagem);
                break;
              case "ERRO":
                this.$message.error(response.mensagem);
                break;
            }
          }).catch(() => {
            this.hideLoading();
          });
          this.$emit('close');
        }
      })
    },
    fechar() {
      this.$emit('close');
    }    
  }
}
</script>
<style scoped>
.details{
  display: flex;
  flex-direction:  column;
  margin: 10px 0;
  padding: 10px;
  background-color: #f9f9f9;
  border-left: 4px solid #28a745;
  border-radius: 5px;
}
.font-label{
  font-weight: bold;
  font: 15px;
  margin-bottom: 5px;
  color: rgb(66, 66, 66);
}
.custon-dialog-title{
  text-align: center;
}

</style>